export const TwoColumnsProductCardBP = 1182;
export const BREAK_POINT_MOBILE_MD_LG = 550;